import { useContext } from "react";

import { CarePlanContentInput } from "@/api/generated/models";
import { CarePlanSummaryCard, LayoutContext } from "@/components";
import CarePlanDisplay from "@/conversation/sidebar/CarePlan";
import { CuraiMessageProps } from ".";

type CarePlanProps = CuraiMessageProps & {
  content: CarePlanContentInput;
  title?: string;
};

export default function CarePlan({
  content,
  senderFullNameWithTitle,
  title = "Your Curai Health care plan",
}: CarePlanProps) {
  const { setModalContent } = useContext(LayoutContext);
  return (
    <CarePlanSummaryCard
      title={title}
      eocTitle={content.diagnosis}
      medications={content.medications}
      dataTrackingId="care-plan-card"
      marginVertical="$100"
      onViewCarePlan={() => {
        setModalContent(
          () =>
            ({ onClose }: { onClose: () => void }) => (
              <CarePlanDisplay
                onClose={onClose}
                content={content}
                senderFullNameWithTitle={senderFullNameWithTitle}
              />
            ),
          { dismissOnOverlayPress: true },
        );
      }}
    />
  );
}
